/**
 * Created by han on 12/26/2018.
 */

import $ from '../../util/dom';

export default function Root(mobile, mobileDevice) {
	const root = $('html');

	// responsive
	if ( mobile ) root.addClass('mobile').removeClass('pc');
	else root.addClass('pc').removeClass('mobile');
	// device
	if (!mobileDevice) root.addClass('desktop').removeClass('touch');
	else root.removeClass('desktop').addClass('touch');
};